import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import Cards from "./Cards";
import QuotaSubmissionStatusChart from "./QuotaSubmissionStatusChart";
import { useDispatch, useSelector } from "react-redux";
import {
  getConsumptionByCountry,
  getGeoData,
  getOrderStatus,
  getQuotaSubmissionStatusData,
  getSynchronizationStatus,
  getUserCountries,
  getScenarioCriticalityList,
  setState,
} from "./dashBoardSlice";
import GeoChart from "./GeoChart";
import ConsumptionRatio from "./ConsumptionRatio";
import KPIDashboardModal from "./KPIDashboardModal";
import SearchForm from "./SearchForm";
import SynchronizationStatusModal from "./SynchronizationStatusModal";

export default function Dashboard() {
  const state = useSelector((state) => state.dashboard);
  const { isLoading, allDataLoaded,dataLoaded,totalData } = state;
  const dispatch = useDispatch();
  const drawerOpen = useSelector((store) => store.global.drawerOpen);
  const logedUser = JSON.parse(localStorage.getItem("data"));
  //console.log("The logedUser is",logedUser);

  useEffect(() => {
    dispatch(setState("totalData", 5));
  
    dispatch(getQuotaSubmissionStatusData());
    dispatch(getConsumptionByCountry());
    dispatch(getSynchronizationStatus());
    dispatch(getOrderStatus());
    dispatch(getUserCountries());
    dispatch(getScenarioCriticalityList());
  
    if (logedUser && (logedUser.isHQUser || logedUser.isAdmin)) {
      dispatch(getGeoData());
    }
  }, []);

  if (dataLoaded < totalData) {
    return (
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={dataLoaded < totalData}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: drawerOpen ? "70vw" : "100%" }}>
      <Box>
        <Typography variant="p18w700" sx={{ color: "darkred.light", mt: 10 }}>
          Dashboard
        </Typography>
      </Box>
      <Grid
        container
        justifyContent={"flex-end"}
        columnGap={2}
        rowGap={2}
        marginTop={-5}
      >
        <Grid item>
          <KPIDashboardModal />
        </Grid>
        <Grid item>
          <SynchronizationStatusModal />
        </Grid>
      </Grid>
      <Grid sx={{ mt: 2 }} container spacing={2}>
        <Grid item sm={6} md={6} lg={6} xs={6}>
          <QuotaSubmissionStatusChart />
        </Grid>
        <Grid  item sm={6} md={6} lg={6} xs={6}>
          <ConsumptionRatio />
        </Grid>
      </Grid>
      {logedUser && (logedUser.isHQUser || logedUser.isAdmin) &&
      (<Grid item>
        <GeoChart />
      </Grid>) 
      }
      <Grid item>
        <SearchForm />
      </Grid>
    </Box>
  );
}
